import { createStyles, Tabs } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type TabFieldType = BaseField & {
  type: 'TabField';
  options: { label: string; value: string }[];
  defaultValue: string;
};

const useStyles = createStyles((theme) => ({
  tabsList: {
    flexWrap: 'nowrap',
    overflowX: 'scroll',
    borderTop: `1px solid ${theme.colors.gray[0]}`,
    borderBottom: 'none',
  },
  tab: {
    '&:hover': {
      background: 'none',
    },
    '&[data-active]': {
      color: theme.colors.splash[4],
    },
  },
  tabLabel: {
    fontWeight: 'bold',
  },
}));

function TabFieldElement({ field, onValueChange }: StaticFieldProps<TabFieldType>) {
  const { classes } = useStyles();

  return (
    <Tabs classNames={classes} defaultValue={field.defaultValue}>
      <Tabs.List>
        {field.options.map((option) => (
          <Tabs.Tab
            key={option.value}
            fz={16}
            onClick={() => onValueChange(option.value)}
            value={option.value}
          >
            <Text variant="headline-small">{option.label}</Text>
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
}

const Descriptor: FieldDescriptor<TabFieldType> = {
  FieldComponent: TabFieldElement,
  name: 'TabField',
};

export default Descriptor;
